import { Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
// import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
export class AuthService {
  // constructor(public jwtHelper: JwtHelperService) { }
  constructor(public storage: StorageService) { }
  public async isAuthenticated() {
    // let userJson = JSON.parse(localStorage.user);
    // let token = userJson.token; // Token 
    const token = await this.storage.getStorage('user'); // Login Success Create Token
    if (token) {
      return true;
    }
    // return !this.jwtHelper.isTokenExpired(token);
    return false;
  }

}
